import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./SelectPlan.module.scss";
import PlanCard from "../../components/PlanCard/PlanCard";
import TermAndcondition from "../../components/termAndcondition";
import userStore from "../../zustand/user.store";
import { userActions } from "../../actions";
import { get, isEmpty } from "lodash";
import { generalConstants } from "../../constants";
import { ROUTES } from "../../constants/routes.constants";
import Button, { BUTTON_TYPES } from "../../components/button/Button";

const SelectPlan = () => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const [billingStatus, setBillingStatus] = useState(null);
  const {
    setUser,
    user: userData,
    userOffline,
  } = userStore((state) => ({
    setUser: state.setUser,
    user: state.user,
    userOffline: state.userOffline,
  }));

  const handleSubmit = (type, price) => {
    // If user is logged in and has already accepted T&C, skip the T&C popup
    const isTncAccepted = get(userData, "is_tnc_accepted", false);
    const isAuthenticated = !isEmpty(get(userData, "id", ""));

    if (isAuthenticated && isTncAccepted) {
      setUser({
        ...userData,
        plan: { type, price },
      });
      // Directly initiate payment if T&C already accepted
      handleDirectPayment(type);
    } else {
      setVisible(true);
      setUser({
        ...userData,
        plan: { type, price },
      });
    }
  };

  const handleDirectPayment = async (type) => {
    const initiatePaymentRes = await userActions.initiatePaymentAction(
      { plan_type: type },
      userOffline
    );

    if (initiatePaymentRes.success) {
      const checkout = get(initiatePaymentRes, "data", null);
      const url = get(initiatePaymentRes, "data.url", "");
      const transactionId =
        get(initiatePaymentRes, "data.transactionId", "") ||
        get(initiatePaymentRes, "data.transaction_id", "");
      try {
        if (transactionId && checkout) {
          sessionStorage.setItem(
            `billing:checkout:${transactionId}`,
            JSON.stringify(checkout)
          );
        }
      } catch (e) {
        // ignore
      }
      navigate(
        `/payment?paymentUrl=${encodeURIComponent(
          url
        )}&transactionId=${encodeURIComponent(transactionId)}`
      );
    }
  };

  useEffect(() => {
    const fetchStatus = async () => {
      const res = await userActions.fetchBillingStatusAction(userOffline);
      if (res?.success) setBillingStatus(get(res, "data", null));
    };
    fetchStatus();
  }, [userOffline]);

  const pricing = useMemo(() => {
    const apiPricing = get(billingStatus, "pricing", null);
    return {
      radio_monthly:
        get(apiPricing, "radio_monthly", null) ??
        generalConstants.PLAN_TYPE_VS_PRICE["RADIO"],
      unlimited_monthly:
        get(apiPricing, "unlimited_monthly", null) ??
        generalConstants.PLAN_TYPE_VS_PRICE["UNLIMITED"],
      trial_days: get(apiPricing, "trial_days", null) ?? 3,
    };
  }, [billingStatus]);

  return (
    <div className={styles.SelectPlan}>
      {visible && <TermAndcondition setVisible={setVisible} visible={visible} />}
      <div className={styles.profileLinkContainer}>
        <Button
          type={BUTTON_TYPES.TERTIARY}
          onClick={() => navigate(ROUTES.PROFILE)}
          className={styles.profileBtn}
        >
          Go to Profile
        </Button>
      </div>
      <div className={styles.heading}>
        <h1 className={styles.title1}>Select your Package</h1>
        <p className={styles.title2}>
          Choose the plan that’s right for your business
        </p>
      </div>
      <div className={styles.cards}>
        {/* <PlanCard
          handleSubmit={() =>
            handleSubmit("TRIAL", generalConstants.PLAN_TYPE_VS_PRICE["TRIAL"])
          }
          Title={"Trial"}
          Price={"Free"}
          Desc={[
            `Access the player from a single device`,
            `Enjoy over 40,000 tracks, organized into ad-free playlists by style`,
            `Create personal playlists of your favorite music`,
            `Schedule playlists to suit any time of the day`,
            `Mark your favorite songs and block the ones you don't`,
            `Valid for 30 days Only`,
          ]}
        /> */}
        <PlanCard
          handleSubmit={() =>
            handleSubmit("RADIO", pricing.radio_monthly)
          }
          Title={"Radio"}
          Price={`$${pricing.radio_monthly}`}
          Desc={[
            `${pricing.trial_days} day free trial`,
            "Access the player from a single device",
            "Enjoy over 40,000 tracks, organized into radio stations by style",
            "Listen to more than 25 ad-free radio stations",
            "Schedule radio station playback",
            "Includes a license for business use",
          ]}
        />
        <PlanCard
          isFeatured={true}
          handleSubmit={() =>
            handleSubmit(
              "UNLIMITED",
              pricing.unlimited_monthly
            )
          }
          Title={"Unlimited"}
          Price={`$${pricing.unlimited_monthly}`}
          Desc={[
            `Access the player from a single device`,
            `Enjoy over 40,000 tracks, organized into ad-free playlists by style`,
            `Create personal playlists of your favorite music`,
            `Schedule playlists to suit any time of the day`,
            `Mark your favorite songs and block the ones you don't`,
            `Includes a license for business use`,
            `And more...`,
          ]}
        />
        <PlanCard
          handleSubmit={() =>
            window.open("https://4-play.io/contactus", "_blank")
          }
          Title={"Enterprise"}
          Price={"Custom Solution"}
          Desc2={"For chains with 10+ locations"}
          buttonText={"Contact Us"}
          // followUpMessage={
          //   "A representative will contact you within 24 hours for a custom quote"
          // }
          Desc={[
            "Custom solution tailored to your organization",
            "Centralized management of all locations",
            "24/7 advanced technical support",
            "Professional installation and team training",
            "Advanced reporting and analytics",
            "Integration options with existing systems",
            "Special volume pricing",
            "Guaranteed Service Level Agreement (SLA)",
          ]}
        />
      </div>
    </div>
  );
};

export default SelectPlan;
